import { render, staticRenderFns } from "./ListagemMenusComponent.vue?vue&type=template&id=0fa2687b"
import script from "./ListagemMenusComponent.vue?vue&type=script&lang=js"
export * from "./ListagemMenusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports